import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const PushapiBlockTable = ({ report, onSortChange, onRemove }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} onRemove={onRemove}/>));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('day')}>Day</th>
                    <th onClick={() => onSortChange('affid')}>Affid</th>
                    <th onClick={() => onSortChange('subid')}>Subid</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiBlockTable;


// WEBPACK FOOTER //
// ./src/scenes/PushapiBlock/components/Table/index.js